//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/RoutingCommon.js";
import "../no/Builder.js";
import "../no/Expression.js";
let d=[[[0,"AddExtensionToggle",1,0],[0,"BackwardExtension",1,"Expression",0],[0,"BoxOrientation",1,0],[0,"ConnectedObject",1,"NXObject",0],[0,"EndPoint",1,"Point",0],[0,"ExtensionVector",1,"Direction",0],[0,"ForwardExtension",1,"Expression",0],[0,"HealSolutionCsys",1,"CoordinateSystem",0],[0,"HealTraversalOrder",1,0],[0,"PathForwardThroughExtensionVector",1,0],[0,"TransitionType",1,0]],[],[]];
SPLM.RoutingCommon.PathTransitionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.RoutingCommon.PathTransitionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.RoutingCommon.PathTransitionBuilder.Type = Object.freeze({
    "Direct" : "Direct", "Heal" : "Heal", "Intersect" : "Intersect"});

SPLM.RoutingCommon.PathTransitionBuilder.TraversalOrder = Object.freeze({
    "Xyz" : "Xyz", "Xzy" : "Xzy", "Yzx" : "Yzx", "Yxz" : "Yxz", "Zxy" : "Zxy", "Zyx" : "Zyx", "Invalid" : "Invalid"});

SPLM.RoutingCommon.PathTransitionBuilder.HealOrientation = Object.freeze({
    "Wcs" : "Wcs", "Absolute" : "Absolute", "Start" : "Start", "End" : "End", "NewCsys" : "NewCsys"});

export default SPLM;